// educatorDashboardStudentTables
import Image1 from 'shared/img/educator-app-intro-module-image-1.svg';
import Image2 from 'shared/img/educator-app-intro-module-image-2.svg';
import Image3 from 'shared/img/educator-app-intro-module-image-3.svg';
import Image4 from 'shared/img/educator-app-intro-module-image-4.svg';
import Image5 from 'shared/img/educator-app-intro-module-image-5.svg';

export const EDUCATOR_APP_INTRO_MODULE_CONTENT = {
  1: {
    title: 'Welcome, {{NAME}}!',
    text: 'Take this quick tour to see how you can help your students prepare for college and stay motivated.',
    DisplayImage: Image1,
  },
  2: {
    title: 'Take the guesswork out of the cost of college',
    text: 'On Raise Me, students can better estimate their financial aid before they even apply by showing them the minimum of what they could be getting in scholarships and grants from that college!',
    DisplayImage: Image2,
  },
  3: {
    title: 'There’s more to a school than meets the eye',
    text: 'Students can search and discover colleges based on their academic interests and other factors such as cost, location, and student life in order to find their best fit.',
    DisplayImage: Image3,
  },
  4: {
    title: 'Your college checklist',
    text: 'When students add achievements - classes, activities, even supporting their families - they receive immediate positive feedback as they watch their micro-scholarships pile up.',
    DisplayImage: Image4,
  },
  5: {
    title: "All right, {{NAME}}, let's go!",
    text: 'Invite your students to Raise Me! You’ll be able to track their progress, send them reminders, and help them realize their college dreams.',
    DisplayImage: Image5,
  },
};
